import { render, staticRenderFns } from "./NewManualDetail.vue?vue&type=template&id=63556e3b&scoped=true"
import script from "./NewManualDetail.vue?vue&type=script&lang=js"
export * from "./NewManualDetail.vue?vue&type=script&lang=js"
import style0 from "./NewManualDetail.vue?vue&type=style&index=0&id=63556e3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63556e3b",
  null
  
)

export default component.exports